function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.4,5.75h-69A4.54,4.54,0,0,0,7,10.35V41.4a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1V79.84a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V55.55A3.4,3.4,0,0,0,12,52.71a3.28,3.28,0,1,0-6.55,0A3.37,3.37,0,0,0,7,55.55V79.84a4.54,4.54,0,0,0,4.48,4.59h69a4.54,4.54,0,0,0,4.48-4.59V10.35A4.54,4.54,0,0,0,80.4,5.75Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.92,63.84V30.19h4.82V63.84Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,30.19l-6.9,33.65H47.61L40.76,30.19h5.11l3.82,23.49h.1l3.87-23.49Z",
    style: {
      fill: "#0075c9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvIcon);
export default __webpack_public_path__ + "static/media/ivIcon.935ec4a6.svg";
export { ForwardRef as ReactComponent };